<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    <ng-container
      *ngTemplateOutlet="
        documentFormTemplate;
        context: {
          document: 'passport',
          showSignal: showPassport,
          required: nationality() !== 'pl',
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        documentFormTemplate;
        context: {
          document: 'identityDocument',
          showSignal: showIdentityDocument,
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        documentFormTemplate;
        context: {
          document: 'residenceCard',
          showSignal: showResidenceCard,
        }
      "
    ></ng-container>

    @if (nationality() !== Country.PL) {
      <ng-container
        *ngTemplateOutlet="
          documentFormTemplate;
          context: {
            document: 'polishCard',
            showSignal: showPolishCard,
          }
        "
      ></ng-container>
    }
  </form>
</onyx-section>

<ng-template
  let-document="document"
  let-showSignal="showSignal"
  let-required="required"
  #documentFormTemplate
>
  <onyx-toggle
    [label]="`labels.${document}`"
    [checked]="showSignal()"
    [disabled]="required"
    (checkedChange)="$any(showSignal).set($event)"
  ></onyx-toggle>

  @if (showSignal()) {
    @let formGroup = $any(form().get(document));
    <ng-container [formGroup]="formGroup">
      @let controls = formGroup.controls;
      <onyx-text-field
        [formControl]="controls.number"
        [label]="`labels.${document}Number`"
        textTransform="uppercase"
        [size]="32"
      ></onyx-text-field>

      <onyx-dropdown
        [formControl]="controls.issuingCountry"
        label="labels.issuingCountry"
        [options]="countries$ | async"
        [search]="true"
        [size]="32"
      ></onyx-dropdown>

      <onyx-datepicker
        [formControl]="controls.expirationDate"
        label="labels.expirationDate"
        [yearsRange]="{ past: 0, future: 10 }"
        [warningTypes]="['pastDate']"
        [size]="32"
      ></onyx-datepicker>

      <onyx-upload
        [formControl]="controls.scans"
        [label]="`labels.${document}Scan`"
        [limit]="2"
        [size]="32"
      ></onyx-upload>
    </ng-container>
  }
</ng-template>
